module.exports = __webpack_public_path__ + "img/healthcare-menu-cafeteria.dfa7aafc.png";